import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';

const root = createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain="dev-kuni.us.auth0.com"
    clientId="lnCMB0qRHlRia4AAs3sW8lNd21oUsEgl"
    redirectUri={window.location.origin + (process.env.PUBLIC_URL || "")}
  >
    <App />
  </Auth0Provider>
);
